import { useState, useCallback } from 'react';
import { ScreenDataMap, ScreenState, ScreenType } from '../types';

interface UseScreensReturn {
  screenType: ScreenType;
  data: ScreenDataMap[ScreenType];
  setScreen: <T extends ScreenType>(params: { screenType: T; data?: ScreenDataMap[T] }) => void;
  reset: () => void;
}

/**
 * Manages which “screen” is active and an optional payload.
 *
 * @param defaultScreen – the ScreenType to show initially
 */
export const useScreens = (defaultScreen: ScreenType): UseScreensReturn => {
  const [state, setState] = useState<ScreenState<ScreenType>>({
    screenType: defaultScreen,
    data: undefined as ScreenDataMap[ScreenType],
  });

  const setScreen = useCallback(<T extends ScreenType>(params: { screenType: T; data?: ScreenDataMap[T] }) => {
    setState(params);
  }, []);

  const reset = useCallback(() => {
    setState({ screenType: defaultScreen, data: undefined as ScreenDataMap[ScreenType] });
  }, [defaultScreen]);

  return {
    screenType: state.screenType,
    data: state.data,
    setScreen,
    reset,
  };
};
